var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-page"},[_c('div',[_c('article-info')],1),(_vm.carouselImg.icon)?_c('viewer',{ref:"viewer",attrs:{"images":[_vm.carouselImg.icon]}},[_c('img',{attrs:{"src":_vm.carouselImg.icon,"alt":""}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }